/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleGroup extends models.BillingRule {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleGroup");
    }

    getFixupPrototypeFunction() { return BillingRuleGroup.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleGroup>): BillingRuleGroup {
        let obj = Object.assign(new BillingRuleGroup(), model);
        BillingRuleGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleGroup>): BillingRuleGroup {
        if (!model) return null;
        return BillingRuleGroup.newInstance(<BillingRuleGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleGroup) {
        if (!obj) return;

        models.BillingRuleGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleGroup): boolean {
        if (models.BillingRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.rules) {
            for (let val of this.rules) {
                models.BillingRule.fixupPrototype(val);
            }
        }
    }

    /**
     * List of rules
     */
    rules: Array<models.BillingRule>;

}
